module.exports = __webpack_public_path__ + "img/baty-chesseboeuf.e2f36b7f.png";